import { useState } from "react";
import PricingToggle from "./PricingToggle";
import PricingCard from "./PricingCard";
import ComparisonModal from "./ComparisonModal";
import FAQ from "./FAQ";
import Testimonials from "./Testimonials";
import { Button } from "../../ui/button";

const Pricing = () => {

    const [showComparison, setShowComparison] = useState<boolean>(false);
    const [isYearly, setIsYearly] = useState<boolean>(false);
    const [currency, setCurrency] = useState<"INR" | "USD">("INR");

    const plans = [
        {
            name: "Free",
            team: "Free Forever",
            staff_price: 0,
            team_inr: 0,
            team_usd: 0,
            staff_inr: 0,
            staff_usd: 0,
            color: "free",
            description: "Perfect for individuals getting started",
            features: [
                { name: "Up to 4 team members", included: true },
                { name: "Online Business Page", included: true },
                { name: "Add Image Gallery", included: true },
                { name: "Show Google Review", included: true },
                { name: "Add Customer's Review", included: true },
                { name: "Google Map Address", included: true },
                { name: "Get Online Booking", included: true },
                { name: "Manage Services", included: true },
                { name: "Email Notifications", included: true },
                { name: "WhatsApp Notifications", included: true },
                { name: "Manage Customers", included: false },
                { name: "POS Quick Sale", included: false },
                { name: "Create Invoice", included: false },
                { name: "Send Invoice on WhatsApp", included: false },
                { name: "Manage Staff", included: false },
                { name: "Real Time Status", included: false },
                { name: "Sales Report", included: false },
                { name: "Manage Cakendar", included: false },
                { name: "Manage Membership ", included: false },
                { name: "Manage Expenses", included: false },
                { name: "Manage Discounts", included: false },
                { name: "Unlimited Coupon", included: false },
                { name: "Manage Inventory", included: false },
                { name: "Unlimited Products", included: false },
                { name: "Sale Products", included: false },
            ],
            cta: "Try for Free",
        },
        {
            name: "Startup",
            team_inr: 9589,
            team_usd: 12,
            staff_inr: 199,
            staff_usd: 3,
            color: "startup",
            description: "Best for small teams and growing businesses",
            features: [
                { name: "Up to 4 team members", included: true },
                { name: "Online Business Page", included: true },
                { name: "Add Image Gallery", included: true },
                { name: "Show Google Review", included: true },
                { name: "Add Customer's Review", included: true },
                { name: "Google Map Address", included: true },
                { name: "Get Online Booking", included: true },
                { name: "Manage Services", included: true },
                { name: "Email Notifications", included: true },
                { name: "WhatsApp Notifications", included: true },
                { name: "Manage Customers", included: true },
                { name: "POS Quick Sale", included: true },
                { name: "Create Invoice", included: true },
                { name: "Send Invoice on WhatsApp", included: true },
                { name: "Manage Staff", included: true },
                { name: "Real Time Status", included: true },
                { name: "Sales Report", included: true },
                { name: "Manage Calendar", included: true },
                { name: "Manage Membership ", included: true },
                { name: "Manage Expenses", included: true },
                { name: "Manage Discounts", included: true },
                { name: "Unlimited Coupon", included: true },
                { name: "Manage Inventory", included: false },
                { name: "Unlimited Products", included: false },
                { name: "Sale Products", included: false },
            ],
            cta: "Startup Plan",
        },
        {
            name: "Premium",
            team_inr: 11998,
            team_usd: 12,
            staff_inr: 249,
            staff_usd: 3,
            color: "premium",
            description:
                "Ideal for established businesses that need advanced tools, scalability, and complete control.",
            features: [
                { name: "Up to 4 team members", included: true },
                { name: "Online Business Page", included: true },
                { name: "Add Image Gallery", included: true },
                { name: "Show Google Review", included: true },
                { name: "Add Customer's Review", included: true },
                { name: "Google Map Address", included: true },
                { name: "Get Online Booking", included: true },
                { name: "Manage Services", included: true },
                { name: "Email Notifications", included: true },
                { name: "WhatsApp Notifications", included: true },
                { name: "Manage Customers", included: true },
                { name: "POS Quick Sale", included: true },
                { name: "Create Invoice", included: true },
                { name: "Send Invoice on WhatsApp", included: true },
                { name: "Manage Staff", included: true },
                { name: "Real Time Status", included: true },
                { name: "Sales Report", included: true },
                { name: "Manage Calendar", included: true },
                { name: "Manage Membership ", included: true },
                { name: "Manage Expenses", included: true },
                { name: "Manage Discounts", included: true },
                { name: "Unlimited Coupon", included: true },
                { name: "Manage Inventory", included: true },
                { name: "Unlimited Products", included: true },
                { name: "Sale Products", included: true },
            ],
            cta: "Premium Plan",
        },
    ];

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
            {/* Header */}
            <div className="container mx-auto px-4 pt-4 pb-8">
                <div className="text-center animate-slide-up">
                    <h1 className="text-5xl font-bold text-gray-900 mb-4 py-2">
                        Feelaxo
                    </h1>
                    <div className="bg-gray-50 py-2 px-4 text-center">
                        <p className="text-m font-semibold text-black tracking-wide mb-4">
                            The All-in-One Beauty Salon & Spa Management Software
                        </p>
                        <h2 className="text-4xl md:text-4xl font-extrabold text-gray-900 mb-2">
                            Scale Your Business with Confidence
                        </h2>
                        <p className="text-lg text-black max-w-2xl mx-auto mb-8">
                            Choose a plan that fits your needs with simple and
                            <br /> transparent pricing.
                        </p>
                    </div>

                    <PricingToggle
                        isYearly={isYearly}
                        onToggle={() => setIsYearly(!isYearly)}
                        currency={currency}
                        onCurrencyToggle={() =>
                            setCurrency(currency === "INR" ? "USD" : "INR")
                        }
                    />
                </div>
            </div>

            {/* Pricing Cards */}
            <div className="container mx-auto px-4 pb-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-screen-2xl mx-auto">
                    {plans.map((plan, idx) => (
                        <PricingCard
                            key={plan.name}
                            plan={plan}
                            delay={idx * 100}
                            currency={currency}
                            isYearly={isYearly}
                        />
                    ))}
                </div>

                <div className=" mt-12 px-4 text-center">
                    <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
                        Ready to take the next step?
                    </h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
                        We'd love to give you a personalized tour and answer all your
                        questions. If you'd rather explore for yourself, start a free trial
                        to see it in action.
                    </p>
                </div>
                {/* Compare Plans Button */}
                {/* Demo & Trial Buttons */}
                <div className="text-center  space-y-4">
                    <div className="flex flex-col md:flex-row justify-center items-center gap-4">
                        <Button
                            onClick={() => alert("Book a Demo clicked")}
                            className="bg-white text-black border-2 border-black hover:bg-green-400 hover:border-green-500 rounded-full text-lg px-8 py-3 transition-colors"
                        >
                            Book a Demo
                        </Button>

                        <Button
                            onClick={() => alert("Start a Trial clicked")}
                            className="bg-green-500 text-black rounded-full hover:bg-green-600 text-lg px-8 py-3 transition-colors"
                        >
                            Start a Trial
                        </Button>
                    </div>

                    {/* Compare Plans Button */}
                    <div>
                        <Button
                            variant="outline"
                            onClick={() => setShowComparison(true)}
                            className="text-lg px-8 py-3 hover:bg-blue-50 transition-colors mt-6"
                        >
                            Compare All Plans ↓
                        </Button>
                    </div>
                </div>
            </div>

            {/* Testimonials */}
            <Testimonials />

            {/* FAQ */}
            <FAQ />

            {/* Comparison Modal */}
            <ComparisonModal
                plans={plans}
                isOpen={showComparison}
                onClose={() => setShowComparison(false)}
                isYearly={isYearly}
                currency={currency}
            />

            {/* <style jsx>{`
        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-slide-up {
          animation: slide-up 0.6s ease-out forwards;
        }
      `}</style> */}
        </div>
    );
};

export default Pricing;

